module.exports = __webpack_public_path__ + "static/media/themify9f24.c4292f34.svg";